import { useStressAssessmentScheduleAlert } from './hooks';
import { StressAssessmentScheduleAlertPresentation } from './presentations';

export const StressAssessmentScheduleAlert: React.FC = () => {
  const { isScheduleSet, onClickSetSchedule, onClickEdit, onClickReset } =
    useStressAssessmentScheduleAlert();
  return (
    <StressAssessmentScheduleAlertPresentation
      isScheduleSet={isScheduleSet}
      onClickSetSchedule={onClickSetSchedule}
      onClickReset={onClickReset}
      onClickEdit={onClickEdit}
    />
  );
};
